import { render, staticRenderFns } from "./RelaticsSidebar.vue?vue&type=template&id=46c844e9&scoped=true"
import script from "./RelaticsSidebar.vue?vue&type=script&lang=js"
export * from "./RelaticsSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46c844e9",
  null
  
)

export default component.exports